// Central site data
export const SERVICES = [
  {
    num: "01",
    title: "Immobilienfotografie",
    desc: "Hochwertige Aufnahmen für Verkauf und Vermietung von Wohn- und Gewerbeobjekten – klar, ehrlich, verkaufsstark.",
  },
  {
    num: "02",
    title: "Architekturfotografie",
    desc: "Präzise Bilder von Fassaden, Bauformen und Innenräumen – für Bauträger, Architekten und Projektentwickler.",
  },
  {
    num: "03",
    title: "Interior & Exterior",
    desc: "Innen- und Außenaufnahmen für Hotels, Ferienwohnungen, Gewerbeflächen und hochwertige Objektpräsentation.",
  },
  {
    num: "04",
    title: "Immobilienvideos",
    desc: "Cinematische Walkthroughs und Reels für Exposé, Website, Social Media und Vermarktungskampagnen.",
  },
  {
    num: "05",
    title: "Drohnenaufnahmen",
    desc: "Luftbilder und Perspektiven aus der Höhe für Häuser, Grundstücke, Gewerbeobjekte und touristische Areale.",
  },
  {
    num: "06",
    title: "3D-Touren & 360°",
    desc: "Virtuelle Rundgänge und 360°-Panoramen zur digitalen Vorqualifikation von Interessenten.",
  },
  {
    num: "07",
    title: "Virtual Staging",
    desc: "Digitale Möblierung leerer Räume – fotorealistisch, ehrlich, vermarktungsstark.",
  },
  {
    num: "08",
    title: "Bildtransformation",
    desc: "Himmel ersetzen, Golden-Hour-Look, störende Elemente entfernen, Bildqualität gezielt steigern.",
  },
  {
    num: "09",
    title: "Grundrisse 2D / 3D",
    desc: "Aus Handskizzen und alten Plänen entstehen saubere, professionelle 2D- und 3D-Grundrisse.",
  },
  {
    num: "10",
    title: "Baudokumentation",
    desc: "Bilddokumentationen für Verwalter, Bauträger, Gemeinden, Versicherungen und Gutachter.",
  },
  {
    num: "11",
    title: "Social-Media-Content",
    desc: "Reels, Hochformat-Assets und Kurzvideos für Instagram, TikTok, Anzeigen und Immobilienportale.",
  },
  {
    num: "12",
    title: "Fotoentwicklung",
    desc: "Professionelle Nachbearbeitung und Qualitätssteigerung bereits vorhandener Immobilienbilder.",
  },
];

export const TARGET_GROUPS = [
  { title: "Immobilienmakler", desc: "Professioneller Content für Exposés, Portale, Website und Social Media." },
  { title: "Eigentümer & Vermieter", desc: "Hochwertige Objektpräsentation für Verkauf, Vermietung und Wahrnehmung." },
  { title: "Bauträger & Projektentwickler", desc: "Visualisierungen für Neubauprojekte, Referenzen und Vermarktungsunterlagen." },
  { title: "Architekten & Unternehmen", desc: "Architektur-, Interior- und Objektfotografie für Websites und Präsentationen." },
  { title: "Hotels, Ferienwohnungen & Airbnb", desc: "Fotos, Videos und Rundgänge für mehr Buchungen und mehr Vertrauen." },
  { title: "Gewerbeimmobilien", desc: "Büros, Hallen, Ladenlokale und Unternehmensstandorte hochwertig präsentiert." },
];

export const CITIES = [
  "Aachen", "Köln", "Düren", "Stolberg", "Alsdorf", "Kerpen",
  "Euskirchen", "Würselen", "Eschweiler", "Hürtgenwald", "Langerwehe", "Zülpich",
];

export const PROCESS_STEPS = [
  { num: "01", title: "Anfrage", desc: "Sie senden uns die wichtigsten Informationen zur Immobilie, zum Standort und zur gewünschten Leistung." },
  { num: "02", title: "Besprechung", desc: "Wir klären gemeinsam Ziel, Objekttyp, Einsatzzweck der Inhalte und den passenden Leistungsumfang." },
  { num: "03", title: "Shooting & Produktion", desc: "Die Immobilie wird professionell fotografiert, gefilmt oder digital aufbereitet." },
  { num: "04", title: "Lieferung", desc: "Sie erhalten finale Inhalte für Exposé, Website, Portale und Social Media." },
];

export const FAQS = [
  {
    q: "Bieten Sie Immobilienfotografie für Makler und Bauträger an?",
    a: "Ja. Wertbild Immobilienfotografie arbeitet für Immobilienmakler, Bauträger, Projektentwickler, Eigentümer, Vermieter und Unternehmen in NRW.",
  },
  {
    q: "Erstellen Sie auch 3D-Touren und Drohnenaufnahmen?",
    a: "Ja. Neben professionellen Immobilienfotos biete ich auch 3D-Touren, virtuelle Rundgänge, 360°-Panoramen und Drohnenaufnahmen für Wohn- und Gewerbeimmobilien an.",
  },
  {
    q: "Bieten Sie nur klassische Immobilienfotos an?",
    a: "Nein. Neben professioneller Immobilienfotografie biete ich auch Architekturfotografie, Interior- und Exteriorfotografie, Drohnen-Luftaufnahmen, 3D-Touren, 360°-Panoramen, Immobilienvideos, Virtual Staging, Grundrisse und digitale Bildoptimierung an.",
  },
  {
    q: "Können auch unfertige oder renovierungsbedürftige Objekte vermarktet werden?",
    a: "Ja. Mit Visualisierungen, Virtual Staging, digitalem Aufräumen, Baustellenretusche und Bildtransformationen lässt sich das Potenzial von Bauprojekten und Bestandsobjekten bereits vor Fertigstellung sichtbar machen.",
  },
  {
    q: "Erstellen Sie auch Inhalte für Airbnb, Ferienwohnungen oder Booking-Portale?",
    a: "Ja. Wertbild erstellt professionelle Fotos, Videos und Rundgänge für Airbnb-Vermittlung, Ferienwohnungen, Hotels und andere Unterkünfte.",
  },
  {
    q: "Bearbeiten Sie auch selbst aufgenommene Fotos nach?",
    a: "Ja. Wertbild übernimmt die professionelle Nachbearbeitung und Qualitätssteigerung bereits vorhandener Immobilienbilder.",
  },
  {
    q: "In welchen Regionen arbeitet Wertbild?",
    a: "Wertbild Immobilienfotografie ist in NRW tätig, mit Schwerpunkt auf Aachen, Köln, Düren und Umgebung. Weitere Regionen sind je nach Projektumfang nach Absprache möglich.",
  },
];

export const PORTFOLIO = [
  { cat: "Wohnimmobilien", img: "https://images.unsplash.com/photo-1622015663381-d2e05ae91b72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjB2aWxsYSUyMGV4dGVyaW9yfGVufDB8fHx8MTc3ODU5NjkzOHww&ixlib=rb-4.1.0&q=85" },
  { cat: "Innenaufnahmen", img: "https://images.unsplash.com/photo-1758448756084-c44d73014c07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwZWxlZ2FudCUyMGJyaWdodCUyMGludGVyaW9yfGVufDB8fHx8MTc3ODU5Njk0Mnww&ixlib=rb-4.1.0&q=85" },
  { cat: "Außenaufnahmen", img: "https://images.unsplash.com/photo-1778205063665-23257f2dc408?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsdXh1cnklMjB2aWxsYSUyMGV4dGVyaW9yfGVufDB8fHx8MTc3ODU5NjkzOHww&ixlib=rb-4.1.0&q=85" },
  { cat: "Drohnenbilder", img: "https://images.unsplash.com/photo-1771033311771-7ec7fa1be3df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxkcm9uZSUyMHNob3QlMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZ3xlbnwwfHx8fDE3Nzg1OTY5NDh8MA&ixlib=rb-4.1.0&q=85" },
  { cat: "3D-Touren", img: "https://images.unsplash.com/photo-1759347137149-2ac7842782cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwZWxlZ2FudCUyMGJyaWdodCUyMGludGVyaW9yfGVufDB8fHx8MTc3ODU5Njk0Mnww&ixlib=rb-4.1.0&q=85" },
  { cat: "Virtual Staging", img: "https://images.unsplash.com/photo-1758548157499-c61b0730dc42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwZWxlZ2FudCUyMGJyaWdodCUyMGludGVyaW9yfGVufDB8fHx8MTc3ODU5Njk0Mnww&ixlib=rb-4.1.0&q=85" },
  { cat: "Gewerbeobjekte", img: "https://images.pexels.com/photos/29334668/pexels-photo-29334668.png" },
  { cat: "Immobilienvideos", img: "https://images.pexels.com/photos/17174767/pexels-photo-17174767.jpeg" },
];

export const NAV_ITEMS = [
  { label: "Start", href: "/#start", id: "start" },
  { label: "Leistungen", href: "/#leistungen", id: "leistungen" },
  {
    label: "Preise",
    id: "preise",
    children: [
      { label: "Immobilienfotografie", href: "/leistungen-preise/immobilienfotografie-preise", id: "preise-foto" },
      { label: "Immobilienvideografie", href: "/leistungen-preise/immobilienvideografie-preise", id: "preise-video" },
    ],
  },
  { label: "Über mich", href: "/#ueber-mich", id: "ueber-mich" },
  { label: "Ablauf", href: "/#ablauf", id: "ablauf" },
  { label: "Portfolio", href: "/#portfolio", id: "portfolio" },
  { label: "Blog", href: "/blog", id: "blog" },
  { label: "Kontakt", href: "/#kontakt", id: "kontakt" },
];

export const CONTACT = {
  name: "Artur Bäcker",
  brand: "Wertbild Immobilienfotografie",
  street: "Arnoldsweilerweg 124A",
  zip: "52353",
  city: "Düren",
  country: "Deutschland",
  phone: "02421 263 370-3",
  email: "kontakt@wertbild.de",
  hours: [
    { d: "Montag – Freitag", t: "09:00 – 17:00 Uhr" },
  ],
  note: "Termine nach Vereinbarung",
};
